module.exports = __webpack_public_path__ + "img/button-icon-edit-disabled.5f10bea1.svg";